enum NumberWorkouts {
  Two = "2",
  Three = "3",
  Four = "4",
  Five = "5",
  AsManyAsPossible = "As many as possible",
}

const numberWorkoutsQuestion = {
  name: "numberWorkouts",
  title: "How many days per week are you able to workout?",
  description: `Pick what you’ll be most consistent with. More isn’t always better.`,
  descriptionLocation: "underTitle",
  type: "radiogroup",
  choices: [
    {
      value: NumberWorkouts.Two,
      text: "2 days",
      visibleIf: "{availableDays.length} >= 2",
    },
    {
      value: NumberWorkouts.Three,
      text: "3 days",
      visibleIf: "{availableDays.length} >= 3",
    },
    {
      value: NumberWorkouts.Four,
      text: "4 days",
      visibleIf: "{availableDays.length} >= 4",
    },
    {
      value: NumberWorkouts.Five,
      text: "5 days",
      visibleIf: "{availableDays.length} >= 5",
    },
    {
      value: NumberWorkouts.AsManyAsPossible,
      text: "6 days",
      visibleIf: "{availableDays.length} >= 6",
      enableIf: "{experience} != 'Beginner'",
    },
  ],
  isRequired: true,
};

export { NumberWorkouts, numberWorkoutsQuestion };
